module.exports = __webpack_public_path__ + "img/Logo1.418b7a92.svg";